import StepBasicInfoController from './stepBasicInfoController';
import './stepBasicInfo.scss';

const StepBasicInfoComponent = {
    template: require('./stepBasicInfoView.html'),
    controller: StepBasicInfoController,
};

export default StepBasicInfoComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepBasicInfo/stepBasicInfoComponent.js